module.exports = __webpack_public_path__ + "media/short_loop-1080p.a4873d46.mp4";